<template>
  <div>
  <vx-card>
      <div class="p-6">
        <div class="flex flex-wrap items-center">
            <vs-input class="mr-4 mb-4" v-model="serverParams.instituteName" placeholder="학원명" @keyup.enter="onSearch"/>
            <vs-input class="mr-4 mb-4" v-model="serverParams.name" placeholder="이름" @keyup.enter="onSearch"/>
            <vs-button class="mb-4" color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            <!-- <vs-button class="mb-4 ml-4" @click="onSearch">검색</vs-button> -->
        </div>

        <vue-good-table
          mode="remote"
          isLoading.sync="isLoading"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-row-click="onRowClick"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 20
          }"
          :sort-options="{
            enabled: true,
            //initialSortBy: {field: 'teacherName', type: 'asc'}
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          />
      </div>
    </vx-card> 
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'
import customFormatter from '../../../utils/customFormatter.js'

export default {
  components: {
    VueGoodTable,
    customFormatter
  },
  data () {
    return {
      isLoading: false,
      teacher_data : null,
      columns: [
        {
          label: '학원명',
          field: 'instituteName',
          type: 'name'
        },
        {
          label: '이름',
          field: 'name',
          type: 'name'
        },
        {
          label: 'ID',
          field: 'teacherID',
          type: 'name'
        },
        {
          label: '휴대폰번호',
          field: 'mobilephone',
          type: 'name',
          sortable: false
        },
        {
          label: '권한',
          field: 'userType',
          formatFn: customFormatter.fomatterUserType,
          type: 'name'
        },
        {
          label: '가입일',
          field: 'createDate',
          type: 'date',
          formatFn: this.createDate,
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 20,
        field: 'InstituteName',
        type: 'ASC',
        instituteName: '',
        name: ''
      }
    }
  },
  computed: {
  },
  methods: {
    createDate (value) {
      return value.split(' ')[0]
    },
    updateParams () {
      const newObj = Object.assign({}, this.serverParams)
      this.$store.dispatch('setTeacherParams', newObj)
    },

    onRowClick (params) {
      const teacherID = params.row.teacherID
      this.$router.push(`/teacher/teacher-view/${teacherID}`)
    },

    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },

    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },

    onSortChange (params) {
      this.serverParams.field = params[0].field
      this.serverParams.type = params[0].type
      this.loadItems()
    },

    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },

    async loadItems () { 
      try {
        
        this.updateParams()

        const { data } = await fetchData('teacher', this.serverParams)
        this.$vs.loading.close()

        this.totalRecords = data.count
        this.rows = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    }
  },
  created () {
    const params = this.$store.getters.getTeacherParams
    this.serverParams = Object.assign({}, params)
    this.loadItems()
  }
}
</script>
